import { alpha } from '@mui/material/styles'

// Superficie compartida por los avisos flotantes (píldoras azul marino sobre el contenido).
export const floatingSurfaceStyles = theme => ({
  bgcolor: alpha(theme.palette.primary.main, 0.94),
  color: theme.palette.text.white,
  border: `1px solid ${alpha(theme.palette.common.white, 0.12)}`,
  backdropFilter: 'blur(6px)',
  boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.35)}`,
})
